import React, { useEffect, useState } from "react";

const StackedImages = ({ images, children }) => {
    // Define state for the transition animation
    const [transition, setTransition] = useState(false);

    // Generate a CSS class name based on the number of images
    const imageCountClass = `stacked-images--${images.length}`;

    // Run the transition animation after the component mounts
    useEffect(() => {
        setTimeout(() => {
            setTransition(true);
        }, 100);
    }, []);

    // Render the stacked images and the footer
    return (
        <>
            {/* Render the stacked images */}
            <div className={`stacked-images ${imageCountClass}`}>
                {images.map((url, index) => (
                    <img
                        key={index}
                        src={url}
                        alt={`Stacked Image ${index}`}
                        crossOrigin="anonymous"
                        className={`stacked-image stacked-image--i${index} ${
                            transition ? "stacked-image--transition" : ""
                        }`}
                    />
                ))}
            </div>

            {/* Render the stacked images again for the screenshot */}
            <div className={`stacked-images ${imageCountClass} stacked-images__screenshot`}>
                {images.map((url, index) => (
                    <img
                        key={index}
                        src={url}
                        alt={`Stacked Image ${index}`}
                        crossOrigin="anonymous"
                        className={`stacked-image stacked-image--i${index} ${
                            transition ? "stacked-image--transition" : ""
                        }`}
                    />
                ))}
            </div>

            {/* Render the footer */}
            <div className="stacked-images__footer">{children}</div>
        </>
    );
};

export default StackedImages;
